<div class="columns is-multiline">
  <app-constitution-readonly-field
    label="Sistema de Administración"
    [value]="administracion().sistema"
    colSize="12"
  />
</div>

@if (administracion().miembros.length > 0) {
  <div class="form-title-container">
    <span class="label" style="font-weight: 300;">Miembros administración</span>
  </div>

  <div class="card" style="margin-bottom: 3rem;">
    <table class="table is-fullwidth is-striped is-hoverable" aria-label="Miembros administración">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">NIF</th>
          <th scope="col">Cargo</th>
          <th scope="col">Fecha de alta</th>
          <th scope="col">Fecha de baja</th>
          <th scope="col" style="text-align: center;">Cons. Delegado</th>
          <th scope="col">Observaciones</th>
        </tr>
      </thead>
      <tbody>
        @for (miembro of administracion().miembros; track miembro.nif + miembro.nombre) {
          <tr
            class="is-clickable"
            tabindex="0"
            (click)="onRowClick(miembro)"
            (keydown)="onRowKeydown($event, miembro)"
          >
            <td>{{ miembro.nombre }}</td>
            <td>{{ miembro.nif }}</td>
            <td>{{ miembro.cargo }}</td>
            <td>{{ miembro.fechaAlta || '—' }}</td>
            <td>{{ miembro.fechaBaja || '—' }}</td>
            <td style="text-align: center;">
              <span [attr.aria-label]="miembro.isCeo ? 'Sí' : 'No'">{{ miembro.isCeoLabel || '' }}</span>
            </td>
            <td>{{ miembro.observations || '—' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
